import { useMutation } from "@tanstack/react-query";
import api from "../utils/api";

export const useResetPassword = () => {
  return useMutation({
    mutationFn: (userData) => {
      return api.put("/user/password", userData);
    },
  });
};
